// import React from 'react'
// import MegaMenu from './MegaMenu';

// const AboutUsMegaMenu = () => {
//   return (
//     <>
//      <MegaMenu menuName="About Us" menuParagraph="Unique Technologies pioneers cutting-edge solutions, blending innovation and expertise to meet diverse technological needs. We're committed to excellence, delivering impactful results that redefine industry standards and empower progress.." firstLink="> About Our Company" secondLink="> About Our Team" thirdLink="> Our Certifications" fourthLink="> Our Newsletter" url_1="/about-us" url_2="/about-our-team" url_3='/our-certifications' url_4="/our-newsletter"/>
//     </>
//   )
// }

// export default AboutUsMegaMenu;

import React from 'react';
import './ContactUsMenu.css';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { NavLink } from 'react-router-dom';

const AboutUsMegaMenu = () => {
  return (
    <>
     <div id='services-menu' style={{}}>
      <NavLink style={{textDecoration:"none"}} to="/about-us"><p><ArrowRightAltIcon/> About our company</p></NavLink>
      
      <NavLink style={{textDecoration:"none"}} to="/about-our-team"><p><ArrowRightAltIcon/> About our team</p></NavLink>
      
      <NavLink style={{textDecoration:"none"}} to="/our-certifications"><p><ArrowRightAltIcon/> Our Certifications</p></NavLink>
      
     <NavLink style={{textDecoration:"none"}} to="/our-newsletter"> <p><ArrowRightAltIcon/>  Our Newsletter</p></NavLink>
      
     
     </div>
    </>
  )
}

export default AboutUsMegaMenu
